import React from 'react';
import RolesTable from './RolesTable';

export default function RolesPage() {
  return (
    <div className="eduss-page-wrapper">
      <RolesTable />
    </div>
  );
}